module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lit-list-view"
  }, [_c('h4', [_vm._v("Список литературы")]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "flip-list"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('item', {
      key: item.id,
      attrs: {
        "content": item.content,
        "label": item.label
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67dcc870"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LitListView.vue
// module id = 1011
// module chunks = 1